import React from "react";
import debounce from "lodash/debounce";
import { Flex, Box } from "grid-styled";
import PropTypes from "prop-types";
import Button from "../Button";
import ButtonToolbar from "../ButtonToolbar";
import { Label, TextArea } from "../forms";

class ProductionStepCompleteForm extends React.Component {
  state = {
    comment: ""
  };

  static defaultProps = {
    onCancel: () => false,
    onSubmit: () => false
  };

  static propTypes = {
    serviceId: PropTypes.string.isRequired,
    currentStep: PropTypes.shape({
      name: PropTypes.string
    }).isRequired,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func
  };

  componentDidMount = () => {
    this.getStateFromLocalStorage();
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.onSubmit(this.state.comment);
  };

  handleCommentChange = e => {
    const comment = e.target.value;
    this.setState({ comment });
    this.saveStateToLocalStorage();
  };

  getStateFromLocalStorage = () => {
    const { serviceId, currentStep } = this.props;
    if (serviceId && currentStep && window.localStorage) {
      const currentDraft = window.localStorage.getItem(
        `stepCommentDraft:${serviceId}:${currentStep.value}`
      );
      if (currentDraft) {
        this.setState({ ...JSON.parse(currentDraft) });
      }
    }
  };

  saveStateToLocalStorage = debounce(() => {
    const { serviceId, currentStep } = this.props;
    if (serviceId && currentStep && window.localStorage) {
      const { comment } = this.state;
      window.localStorage.setItem(
        `stepCommentDraft:${serviceId}:${currentStep.value}`,
        JSON.stringify({ comment })
      );
    }
  }, 500);

  render() {
    const { name: stepName } = this.props.currentStep;

    return (
      <form onSubmit={this.handleSubmit}>
        <Box pb={2}>
          <Label>Notes</Label>
          <TextArea
            name="stepComment"
            rows="10"
            value={this.state.comment}
            onChange={this.handleCommentChange}
          />
        </Box>
        <Flex justify="flex-end">
          <ButtonToolbar>
            <Button type="button" onClick={this.props.onCancel}>
              Cancel
            </Button>
            <Button type="submit" primary>
              Complete {stepName ? stepName : "Step"}
            </Button>
          </ButtonToolbar>
        </Flex>
      </form>
    );
  }
}

export default ProductionStepCompleteForm;



// WEBPACK FOOTER //
// ./src/components/services/ProductionStepCompleteForm.js